import { useEffect, useState } from 'react';

/**
 * En v1 no hay streaming, asi que no sabemos en tiempo real que esta
 * consultando el modelo. En vez de inventarnos un detalle que no tenemos, el
 * texto va contando lo que si es cierto en cada tramo de la espera. Cuando
 * llega la respuesta se enseñan las consultas reales en "Ver de donde salen
 * estos datos".
 */
const STEPS = [
  'Alexia está leyendo tu pregunta…',
  'Consultando tus datos del periodo…',
  'Revisando tus cuentas antes de responder…',
];

const STEP_MS = 2200;

export function ThinkingIndicator(): JSX.Element {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setStep((current) => Math.min(current + 1, STEPS.length - 1));
    }, STEP_MS);
    return () => window.clearInterval(timer);
  }, []);

  return (
    // Sin role="status": ya vive dentro de la region aria-live de la
    // conversacion y duplicaria el anuncio del lector de pantalla.
    <p className="thinking">
      <span className="thinking__dots" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
      {STEPS[step]}
    </p>
  );
}
